import {MODULE_DISTRIBUTION_APP} from '../../../constants/main.module.constants';
export const MODULE_LAYOUT = MODULE_DISTRIBUTION_APP + '.layout';
import {MODULE_CONTENT_LAYOUT} from './content/index';

angular.module(MODULE_LAYOUT, [MODULE_CONTENT_LAYOUT]);



// WEBPACK FOOTER //
// ./modules/distribution/layouts/index.js